export enum TreeListTypesEnum {
    normal,
    social
}
